
// 订单详情页面——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `page/orderDetails/index${i + 1}`,
  name: `page/orderDetailsIndex${i + 1}`,
  component: () => import(`@/views/recognize/page/orderDetails/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 订单详情页面——主流程，开始
    ...MainRoutes
  ]
}
